import styled from 'styled-components';

import { TileContainer } from '~src/styles/containers.sc';

import { ProgressCol } from './shared.sc';

export const ObjectiveTile = styled(TileContainer)`
  font-size: 1rem;
  display: flex;
  flex-wrap: nowrap;
  margin-bottom: 5px;
  color: ${({ theme }) => theme.baseBlue.a10};
  transition: box-shadow 0.4s;

  &:hover {
    box-shadow: 0 6px 13px ${({ theme }) => theme.black.a2};
    z-index: 2;
  }

  ${ProgressCol} {
    justify-content: flex-end;
  }
`;

export const LabelsList = styled.div`
  width: 100%;
  display: flex;
  overflow: hidden;
  position: relative;
  align-items: center;
`;

export const Label = styled.div`
  padding: 2px 9px;
  border-radius: 20px;
  font-size: 0.8rem;
  color: ${({ theme }) => theme.baseBlue.a10};
  background-color: ${({ theme }) => theme.background};
  white-space: nowrap;
  margin-right: 5px;
  cursor: default;
`;

export const LabelOverlay = styled.span<{ $withCounter?: boolean }>`
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;
  background: linear-gradient(
    to right,
    transparent,
    #fff ${({ $withCounter }) => ($withCounter ? '30%' : '100%')}
  );
  padding-left: 30px;
  ${Label} {
    margin-right: 0;
  }
`;
